<div class="career">
  <h2 class="title">{{ 'career.title' | translate }}</h2>

  <div [dir]="userLang === 'ar' ? 'rtl' : 'ltr'">
    <div class="carousel-wrapper">
      <p-carousel [value]="articles" [numVisible]="3" [numScroll]="1" [circular]="false"
        [responsiveOptions]="responsiveOptions" [autoplayInterval]="0" [showIndicators]="isMobile"
        [showNavigators]="!isMobile" styleClass="custom-carousel mt-3">

        <ng-template let-item pTemplate="item">
          <div class="card-item-wrapper">
            <div class="card">
              <div class="card-img">
                <img [src]="getFullImageUrl(item.mainImage)" alt="career-img" (error)="onImageError($event)" />
              </div>

              <div class="card-content">
                <p class="date">{{ item.createdAt | date:'dd MMM yyyy' }}</p>

                <div class="header">
                  <h3 class="card-title">{{ loadArticleContent(item) }}</h3>
                  <button class="redirect-btn" (click)="goToDetails(item.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M7 17L17 7M17 7H7M17 7V17" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>

                <p class="card-desc">{{ loadArticleDesc(item) }}</p>
              </div>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </div>

  <button class="see-all-btn" routerLink="/articles">
    {{ 'career.see_all' | translate }}
  </button>
</div>